export default __webpack_public_path__ + "static/logo-emblem-3294c42bca02d5cf8d8fc71aa9df02c1.svg";